module.exports = __webpack_public_path__ + "img/recent-update-placeholder.ed3a3fe1.svg";